// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1Ws0H","footer":"ModalError_footer__1LXhC"};